import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { msalInstance } from '../index';
import { getAzureAdClientId } from './runtimeConfig';

const apiScope = `${getAzureAdClientId()}/InternalApi`;

/**
 * Creates a fetchBaseQuery pre-configured with MSAL silent-token acquisition.
 * Eliminates the duplicated prepareHeaders block across every API slice.
 */
export const createAuthenticatedBaseQuery = (baseUrl: string | undefined, serviceName: string) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: async (headers) => {
      try {
        const account = msalInstance.getActiveAccount();
        if (account) {
          const { accessToken } = await msalInstance.acquireTokenSilent({
            account,
            scopes: [apiScope],
          });
          headers.set('Authorization', `Bearer ${accessToken}`);
        }
      } catch (e) {
        console.error(`Failed to acquire token for ${serviceName}:`, e);
      }
      return headers;
    },
  });
